import { dayjs } from '../common/lib/dayjs.js'

export const getEventFormattedDate = ({
  startTime,
  endTime,
}: {
  startTime: string
  endTime: string
}) => {
  const formattedStartTime = dayjs(startTime).format('h:mm A')
  const isSameDay = dayjs(startTime).isSame(dayjs(endTime), 'day')
  const formattedEndTime = endTime
    ? dayjs(endTime).format(isSameDay ? 'h:mm A' : 'MMM D, YYYY h:mm A')
    : ''
  const startDateDayOfWeek = dayjs(startTime).format('dddd')
  const endDateDayOfWeek = dayjs(endTime).format('dddd')
  const isSameYear = dayjs(startTime).isSame(dayjs(), 'year')
  const dateWithYear = dayjs(startTime).format('MMM D, YYYY')
  const dateWithoutYear = dayjs(startTime).format('MMM D')
  const date = `${startDateDayOfWeek}, ${isSameYear ? dateWithoutYear : dateWithYear}`

  return {
    date,
    time: endTime
      ? `${formattedStartTime} - ${formattedEndTime}`
      : formattedStartTime,
    startDateTime: dayjs(startTime).format('MMM D, YYYY h:mm A'),
    endDateTime: dayjs(endTime).format('MMM D, YYYY h:mm A'),
    formattedStartTime,
    formattedEndTime,
    startDateDayOfWeek,
    endDateDayOfWeek,
  }
}
